export const farmStatus = {
  COMPLETE: 'Complete',
  INCOMPLETE: 'Incomplete',
} as const;

export type FarmStatus = (typeof farmStatus)[keyof typeof farmStatus];
